import { render, staticRenderFns } from "./CourseColorPicker.vue?vue&type=template&id=4bd939f0&scoped=true&"
import script from "./CourseColorPicker.vue?vue&type=script&lang=js&"
export * from "./CourseColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./CourseColorPicker.vue?vue&type=style&index=0&id=4bd939f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd939f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VListItem,VMenu,VTextField})
